
{
  "buy-card": "Buy Card",
  "check-balance": "Check Balance"
}
